import { useRef, useState } from 'react';
import { SplitDropdownMenu } from './SplitDropdownMenu';

export const SplitButtonCustom = ({ items, className = '', icon = null }) => {
    const [visible, setVisible] = useState(false);
    const buttonRef = useRef(null);

    return (
        <>
            <button
                ref={buttonRef}
                onClick={() => setVisible((v) => !v)}
                className={className ? className : `btn btn-sm btn-icon ${visible ? "!border-dashed !border-gray-400" : ""}`}
            >
                {icon || <i className="fas fa-ellipsis-v"></i>}
            </button>

            <SplitDropdownMenu
                anchorRef={buttonRef}
                items={items}
                visible={visible}
                onClose={() => setVisible(false)}
            />
        </>
    );
};
